import React, { useEffect, useState } from "react";
import axios from "axios";
import { useLocation, useNavigate } from "react-router-dom";
import moment from "moment";
import eye from "../../assets/eye.png";
import { createColumnHelper } from "@tanstack/react-table";
import ReactTable from "../../components/ReactTable";
import CustomPagination from "../../components/CustomPagination";
import { useSelector } from "react-redux";
export const base_url = process.env.REACT_APP_BASE_URL;
export const api_type = process.env.REACT_APP_API_TYPE;

function InvestorManagementParnterDetails() {
  const navigate = useNavigate();
  const [investorUserDetails, setInvestorUserDetails] = useState([]);
  const [investmentsDetails, setInvestmentsDetails] = useState([]);
  const [searchInput, setSearchInput] = useState("");
  const [searchInputApi, setSearchInputApi] = useState("");

  const { userPermissionData } = useSelector((state) => state.userPermission);

  // const [page, setPage] = useState(1);
  const [page, setPage] = useState(() => {
    const savedPage = localStorage.getItem('investmentPartnerDetailsPage');
    return savedPage ? Number(savedPage) : 1;
  });
  const [total, setTotal] = useState(0);
  const [pageSize, setPazeSize] = useState(0);
  const [error, setError] = useState(null);
  const location = useLocation();
  const id = location?.state?.uniqueId;
  const irCode = location?.state?.irCode;

  const fetchInvestorDetails = async () => {
    const endpoint = `${base_url}/${api_type}/investments/partner/${id}`;

    try {
      const response = await axios.get(endpoint, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
        params: {
          search: searchInputApi,
          page: page,
        },
      });
      setInvestorUserDetails(response?.data?.data?.userDetails);
      setInvestmentsDetails(response?.data?.data?.investorDetails);
      setPage(response?.data?.data?.pagination?.currentPage);
      setTotal(response?.data?.data?.pagination?.totalRecords);
      setPazeSize(response?.data?.data?.pagination?.perPage);
    } catch (err) {
      console.error("Failed to fetch pending orders:", err);
      setError(err.message);
    }
  };
  useEffect(() => {
    fetchInvestorDetails();
  }, [searchInputApi, page]);

  // Add useEffect to handle automatic search when input is cleared
  useEffect(() => {
    if (searchInput === '') {
      setSearchInputApi('');
    }
  }, [searchInput]);

  const columnHelper = createColumnHelper();

  const columns = [
    columnHelper.accessor("uccCode", {
      cell: (info) => (info.renderValue() ? info.renderValue() : "N/A"),
      header: () => <span>UCC Code</span>,
    }),

    columnHelper.accessor("name", {
      cell: (info) => (info.renderValue() ? `${info.renderValue()}` : "N/A"),
      header: () => (
        <div className=" ">
          <span>Investor Name</span>
        </div>
      ),
    }),

    columnHelper.accessor("proposedAmount", {
      cell: (info) => (info.renderValue() ? `₹${info.renderValue()}` : "N/A"),
      header: () => (
        <div className=" ">
          <span>Proposed Investment</span>
        </div>
      ),
    }),

    columnHelper.accessor("investment", {
      cell: (info) => (info.renderValue() ? `₹${info.renderValue()}` : "N/A"),
      header: () => (
        <div className=" ">
          <span>Actual Investment</span>
        </div>
      ),
    }),
  ];

  const handleSearchClick = () => {
    setPage(1);
    setSearchInputApi(searchInput);
  };

  const downloadInvestorDetails = async () => {
    const endpoint = `${base_url}/${api_type}/investments/partner/export-to-excel/${id}`;
    try {
      const response = await axios.get(endpoint, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`, // Replace 'your-auth-token' with the actual token
        },
        params: {
          search: searchInputApi,
        },
        responseType: "blob",
      });

      // Create a blob from the response data
      const blob = new Blob([response.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });

      // Create a temporary link to trigger the download
      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.download = `investor_details_${moment().format('YYYY-MM-DD')}.xlsx`;

      // Append the link to the document and trigger the click
      document.body.appendChild(link);
      link.click();

      // Clean up the link and blob URL
      document.body.removeChild(link);
      URL.revokeObjectURL(link.href);
    } catch (err) {
      console.error("Failed to download investor details:", err);
      setError(err.message);
    }
  };
  const onDownloadClick = () => {
    downloadInvestorDetails();
  };

  return (
    <>
      <div className="w-full mt-20  md:px-8">
        <div>
          <button
            onClick={() => window.history.back()}
            className="border-none bg-transparent text-gray-700 text-sm font-bold cursor-pointer py-2.5"
          >
            ← Back to Wealth Partner
          </button>
        </div>

        <div className="bg-white rounded-lg mt-3 mb-5 w-full font-bold border border-1 border-gray-300 pt-5">
          <h2 className="text-md font-bold px-5 py-2.5">
            Wealth Partner Details
          </h2>
          <div className="border-b border-1 border-gray-300 pb-2"></div>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 p-5">
            <div>
              <label className="text-gray-600 text-xs block mb-1.5">
                IR Code
              </label>
              <input
                type="text"
                disabled={true}
                value={irCode}
                placeholder=""
                className="bg-gray-50 p-2.5 rounded w-full text-sm text-gray-600 border-none"
              />
            </div>
            <div>
              <label className="text-gray-600 text-xs block mb-1.5">
                Investor Name
              </label>
              <input
                type="text"
                placeholder="John Smith"
                disabled={true}
                value={investorUserDetails?.name}
                className="bg-gray-50 p-2.5 rounded w-full text-sm text-gray-600 border-none"
              />
            </div>
            <div>
              <label className="text-gray-600 text-xs block mb-1.5">
                Contact Number
              </label>
              <input
                type="text"
                placeholder="15-05-2024"
                disabled={true}
                value={investorUserDetails?.mobileNumber}
                className="bg-gray-50 p-2.5 rounded w-full text-sm text-gray-600 border-none"
              />
            </div>
            <div>
              <label className="text-gray-600 text-xs block mb-1.5">
                Registration Date
              </label>
              <input
                type="text"
                placeholder="15-05-2024"
                disabled={true}
                value={
                  investorUserDetails?.registrationDate
                    ? moment(investorUserDetails?.registrationDate).format(
                        "DD-MM-YYYY"
                      )
                    : "N/A"
                }
                className="bg-gray-50 p-2.5 rounded w-full text-sm text-gray-600 border-none"
              />
            </div>
            <div>
              <label className="text-gray-600 text-xs block mb-1.5">
                No. of Investors Invested
              </label>
              <input
                type="text"
                placeholder="15/11/2024"
                disabled={true}
                value={investorUserDetails?.numberOfInvestorsInvested}
                className="bg-gray-50 p-2.5 rounded w-full text-sm text-gray-600 border-none"
              />
            </div>
            <div>
              <label className="text-gray-600 text-xs block mb-1.5">
                Last Referred User
              </label>
              <input
                type="text"
                disabled={true}
                placeholder="₹850,000"
                value={
                  investorUserDetails?.lastReferradInvestor
                    ? moment(investorUserDetails?.lastReferradInvestor).format(
                        "DD/MM/YYYY"
                      )
                    : "N/A"
                }
                className="bg-gray-50 p-2.5 rounded w-full text-sm text-gray-600 border-none"
              />
            </div>
          </div>
        </div>

        <div className="flex flex-col md:flex-row justify-between items-center mb-3 w-full font-bold text-nowrap">
          <h2>Added Invester</h2>
          <div className="flex flex-col sm:flex-row gap-2.5 flex-grow max-w-full md:max-w-[500px]  mt-3">
            <div className="flex flex-grow">
              <input
                type="text"
                placeholder="Search by Unique ID/name"
                value={searchInput}
                onChange={(e) => setSearchInput(e.target.value)}
                className="px-3 py-2 border border-gray-300 rounded-tl-[10px] rounded-bl-[10px] w-full"
              />
              <button 
                onClick={handleSearchClick}
                className="bg-[#0066b2] text-white border-none px-4 py-2 rounded-tr-[10px] rounded-br-[10px] cursor-pointer"
              >
                Search
              </button>
            </div>
            {userPermissionData?.investment?.download && (
              <button 
                onClick={onDownloadClick}
                className="bg-white border border-[#0066b2] text-[#0066b2] px-4 py-2 rounded-[10px] cursor-pointer"
              >
                Download <i className="fas fa-arrow-down"></i>
              </button>
            )}
          </div>
        </div>

        <div className="w-full font-poppins overflow-x-auto">
          <ReactTable
            key={JSON?.stringify(investmentsDetails)}
            defaultData={investmentsDetails}
            columns={columns}
          />
        </div>

        {investmentsDetails?.length > 0 && (
          <div className="w-auto bg-white mt-4">
            <CustomPagination
              currentPage={page}
              setCurrentPage={setPage}
              totalItems={total}
              itemsPerPage={pageSize}
              maxPageNumbersToShow={5}
              storageKey="investmentPartnerDetailsPage"
            />
          </div>
        )}
      </div>
    </>
  );
}

export default InvestorManagementParnterDetails;
